import { makeStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  select: {
    position: 'relative',
    boxShadow: 'none',
  },
  disabled: {
    border: '1px solid red',
  },
  outlined: {
    '&.MuiSelect-outlined': {
      // maxWidth of the button and paddingRight are used to prevent select text from overflowing into absolutely positioned button
      // material UI's select normally reserves 32px to fit an Icon, but this needs to be increased to accommodate button
      [theme.breakpoints.up('sm')]: {
        paddingRight: '170px',
      },
      paddingRight: '80px',
      borderRadius: '10px',
    },
  },
  button: {
    position: 'absolute',
    right: 0,
    // maxWidth and paddingRight of the outlined input are used to prevent select text from overflowing into absolutely positioned button
    [theme.breakpoints.up('sm')]: {
      maxWidth: '170px',
    },
    maxWidth: '80px',
    justifyContent: 'flex-start',
  },
  notchedOutline: {
    border: '1px solid #e1e1e1',
    borderRadius: '10px',
    '.MuiOutlinedInput-root.Mui-disabled &': {
      borderColor: '#e1e1e1',
    },
  },
  selectedNotchedOutline: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '10px',
    '.MuiOutlinedInput-root.Mui-disabled &': {
      borderColor: theme.palette.primary.main,
    },
  },
  paper: {
    maxHeight: '224px',
    width: 250,
    borderRadius: 10,
    border: '1px solid #e1e1e1',
    boxShadow: 'none',
  },
})

export default makeStyles(styles)
